/* eslint-disable */
jQuery(function ($) {
	// Prevent use of nav arrows on media modal when comment box is open
	// Disabled as it breaks the use of these arrows currently
	// $( '#bb-media-model-container' ).on( 'click', '.theater-command.bb-next-media, .theater-command.bb-prev-media', function( e ) {
	// 	if ( $( '#bb-media-model-container .ac-reply-content' ).is( ':visible' ) ) {
	// 		e.preventDefault();
	// 		e.stopPropagation();
	// 	}
	// });

	// Info links for uploading media
	$( '.info-link' ).on( 'click', function( e ) {
		e.preventDefault();
		$( this ).next( '.info-reveal' ).toggle();
		$( this ).trigger( 'blur' );
	});
	// Handle all custom popup closing
	$( '.ama-popup' ).on( 'click', '.ama-popup-popup-close', function() {
		$( '.ama-popup' ).css( 'display', 'none' );
		$( '.ama-popup-overlay' ).css( 'display', 'none' );
	});

	// Adjust modal content for BB gallery
	$( document ).ajaxComplete(function( event, xhr, settings ) {
		if ( settings.data !== undefined && settings.data.indexOf( 'action=media_get_media_description' ) !== -1 ) {
			// Add tutorial title as header above description
			$( 'span.theatre-tutorial-link' ).remove();
			var activity_id = $( '#bb-media-model-container .activity-list > li:first-of-type' ).attr( 'id' ).replace( 'activity-', '' );
			var title = $( '#media-stream .media-list a.bb-open-media-theatre[data-activity-id="'+activity_id+'"]' ).data( 'media-title' );
			if ( undefined !== title && title.length ) {
				$( '<h4 class="media-title">'+title+'</h4>' ).insertAfter( '#bb-media-model-container .bp-activity-head' );
			}
			// Add link to tutorial in intro message
			var parent_url = $( '#media-stream .media-list a.bb-open-media-theatre[data-activity-id="'+activity_id+'"]' ).data( 'parent-url' );
			var parent_title = $( '#media-stream .media-list a.bb-open-media-theatre[data-activity-id="'+activity_id+'"]' ).data( 'parent-title' );
			if ( ( undefined !== parent_url && undefined !== parent_title ) &&
				( parent_url.length && parent_title.length ) ) {
				$( '<span class="theatre-tutorial-link"> in the <a href="' + parent_url + '">'+parent_title+'</a> gallery</span>' ).insertBefore( '#bb-media-model-container .bb-media-model-inner .bb-media-info-section .bp-activity-head .activity-header a.activity-time-since' );
			}
		}
	});

	// Show load more button on latest uploads widget (redirects to latest uploads gallery)
	$( document ).ajaxComplete(function( event, xhr, settings ) {
		if ( settings.data !== undefined && settings.data.indexOf( 'action=media_filter' ) !== -1 ) {
			$( '#ama-gallery-widget .button.view-more' ).css( 'display', 'block' );
		}
	});

	// Add class to label to highlight selections on preferences page
	$( '#ama-preferences' ).on( 'change', '.section input', function() {
		if ( $( this ).is( ':checked' ) ) {
			$( this ).parent().addClass( 'selected' );
		} else {
			$( this ).parent().removeClass( 'selected' );
		}
	});
});